/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Coin
 */
export interface Coin {
    /**
     * The coin symbol
     * @type {string}
     * @memberof Coin
     */
    ticker?: string;
    /**
     * The coin mint address
     * @type {string}
     * @memberof Coin
     */
    mint: string;
    /**
     * The number of decimals for the coin
     * @type {number}
     * @memberof Coin
     */
    decimals: number;
    /**
     * The ID of the user associated with the coin
     * @type {string}
     * @memberof Coin
     */
    ownerId: string;
    /**
     * URL to the coin's logo image
     * @type {string}
     * @memberof Coin
     */
    logoUri?: string;
    /**
     * A longform description about the coin
     * @type {string}
     * @memberof Coin
     */
    description?: string;
    /**
     * The official website for the coin
     * @type {string}
     * @memberof Coin
     */
    website?: string;
    /**
     * The date and time when the coin was added to Audius.
     * @type {string}
     * @memberof Coin
     */
    createdAt: string;
}

/**
 * Check if a given object implements the Coin interface.
 */
export function instanceOfCoin(value: object): value is Coin {
    let isInstance = true;
    isInstance = isInstance && "mint" in value && value["mint"] !== undefined;
    isInstance = isInstance && "decimals" in value && value["decimals"] !== undefined;
    isInstance = isInstance && "ownerId" in value && value["ownerId"] !== undefined;
    isInstance = isInstance && "createdAt" in value && value["createdAt"] !== undefined;

    return isInstance;
}

export function CoinFromJSON(json: any): Coin {
    return CoinFromJSONTyped(json, false);
}

export function CoinFromJSONTyped(json: any, ignoreDiscriminator: boolean): Coin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ticker': !exists(json, 'ticker') ? undefined : json['ticker'],
        'mint': json['mint'],
        'decimals': json['decimals'],
        'ownerId': json['owner_id'],
        'logoUri': !exists(json, 'logo_uri') ? undefined : json['logo_uri'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'website': !exists(json, 'website') ? undefined : json['website'],
        'createdAt': json['created_at'],
    };
}

export function CoinToJSON(value?: Coin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ticker': value.ticker,
        'mint': value.mint,
        'decimals': value.decimals,
        'owner_id': value.ownerId,
        'logo_uri': value.logoUri,
        'description': value.description,
        'website': value.website,
        'created_at': value.createdAt,
    };
}

